import React, { useEffect, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import ReactImageFallback from "react-image-fallback";
import Cookies from "js-cookie";
// images
import featuredImage from "../assets/images/default_featured_img.png";
import defaultUser from "../assets/images/default_profile_pic.jpg";
import { Button, Modal } from 'react-bootstrap';
import Paypal from "./Payments/Paypal.component";
import { useSelector } from "react-redux";

export default function JobCard(props) {

  const navigate = useNavigate();

  // Cookies.get(`isPaid${props.post.id}`);
  // console.log(Cookies.get(`isPaid${props.post.id}`));

  // Local State 
  const [isPaid, setisPaid] = useState(false);

  // Redux state 
  const userData = useSelector(state => state.auth.data);

  // react-bootstrap
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
  }, [isPaid]);


  const handlePaymentCheck = (e) => {
    e.preventDefault();
    console.log(props.post.assign_post);
    if (userData?.role == 3 && props.post.customer_id == userData?.id) {
      <Navigate to={`/jobs/${props?.post?.id}`} replace />
      return navigate(`/jobs/${props?.post?.id}`, { replace: true });
    }
    else {
      // isPaid ? 
      // navigate(`/jobs/${props?.post?.id}`, { replace: true }) :
      if (props.post.id == Cookies.get(`jobid${props.post.id}`) && Cookies.get(`isPaid${props.post.id}`) == "paid") {
        // console.log("job id Found & user is paid");
        navigate(`/jobs/${props?.post?.id}`, { replace: true })
      } else if (props.post.assign_post !== null) {
        Object.keys(props.post.assign_post).length > 0 && props.post.assign_post.user_id === userData?.id &&
          navigate(`/jobs/${props?.post?.id}`, { replace: true })
      } else {
        handleShow();
      }
    }
  };


  return (
    <>
      <div className="bds-bestservice">
        <figure className="bds-cards__img">
          <Link to={`${props?.post?.id}`} onClick={(e) => handlePaymentCheck(e)}>
            <ReactImageFallback
              src={`https://3bidsapp.com/dev/public/storage/${props?.post?.images[0]?.filepond?.filepath}`}
              fallbackImage={featuredImage}
              initialImage={featuredImage}
              alt="Image Description"
              layout="responsive"
              width={100}
              height={70}
            />
          </Link>
        </figure>
        {/* <span className="bds-featuretag">FEATURED</span> */}
        <div className="bds-sevicesinfo">
          <div className="bds-bestservice__content">
            <figure className="overflow-hidden">
              <ReactImageFallback
                src={`https://3bidsapp.com/dev/public/storage/${props?.post?.customer?.profile_image}`}
                fallbackImage={defaultUser}
                initialImage={defaultUser}
                alt="Image Description"
                width={50}
                height={50}
                className="img-fluid profile_circle_50"
              />
            </figure>
            <div className="bds-cardtitle">
              <div className="bds-like">
                <button type="button" className="btn p-0">
                  <i className="icon-heart"></i>
                </button>
              </div>
              <h6 className="text-sky-blue lh-1 mb-0">{props?.post?.service?.service_name}</h6>
              <h5>
                <Link to={`${props?.post?.id}`} onClick={(e) => handlePaymentCheck(e)}>
                  {props?.post?.title}
                </Link>
              </h5>
            </div>
            
            <div className="bds-startingprice">
              <i>Price:</i>
              <span>
                {" "}
                <span>$</span>{props?.post?.price}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Modal --> */}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="border-0" closeButton></Modal.Header>
        <Modal.Body className="p-4">
          <h3>Please Pay to Bid on this Project</h3>
          <Paypal
            job={props?.post}
            redirectURL={`/jobs/${props?.post?.id}`}
            setisPaid={setisPaid}
            handleClose={handleClose}
          />
        </Modal.Body>
      </Modal>

    </>
  );
}
